import AudioPlayer from '@/components/AudioPlayer';
import { usePlayer } from '@/context/PlayerContext';

/**
 * Mounts <AudioPlayer/> exactly once at the App level so the underlying
 * <audio> element survives every page navigation (and every iOS Safari
 * background-restore). The component is ALWAYS rendered (never gated on
 * `playingTrack`) so the audio element is registered into PlayerContext
 * even before the user has played anything — pages can then call
 * `audio.play()` synchronously inside their click handlers, which is the
 * only way iOS Safari grants background-audio rights and lock-screen
 * controls.
 */
export default function GlobalAudioPlayer() {
  const { playingTrack, queue, handleTrackChange, closePlayer, setIsPlaying } =
    usePlayer();

  return (
    <AudioPlayer
      track={playingTrack}
      tracks={queue}
      onClose={closePlayer}
      onTrackChange={handleTrackChange}
      onPlayingChange={setIsPlaying}
    />
  );
}

